module.exports = __webpack_public_path__ + "media/images/icons/shield-69c1017e4ed1215c7da6f37e0c7e73a4.svg";